export default function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6]
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
	  document.getElementById(a).className = "winner-class";
      document.getElementById(b).className = "winner-class";
      document.getElementById(c).className = "winner-class";	
      return squares[a];
    }
  }
  // check for draw
  let isDraw = true;
  for(let i=0;i<9;i++){
      if(!squares[i]){
          isDraw = false;
      }
  }
  if(isDraw) return 'draw';
  
  return null;
}